/**
 * Local Delivery - Timeslot filtering and availability
 */
(function () {
  'use strict';

  /**
   * Find override entry for a specific date.
   * overrideDays: [{ date, delivery?: { slots }, collection?: { slots }, express?: { slots } }]
   */
  function findOverrideForDate(overrideDays, dateStr) {
    if (!overrideDays || !dateStr) return null;
    for (var i = 0; i < overrideDays.length; i++) {
      if (overrideDays[i].date === dateStr) return overrideDays[i];
    }
    return null;
  }

  /**
   * Resolve slots for a date, considering overrides.
   * If an override exists for the date, its slots replace the default set
   * and day-of-week filtering is skipped (the override IS the slot set).
   * @param {string} mode - 'delivery' | 'collection' | 'express'
   */
  function resolveSlotsForDate(defaultSlots, dateStr, overrideDays, mode) {
    var override = findOverrideForDate(overrideDays, dateStr);
    if (override) {
      var modeData = override[mode || 'delivery'];
      if (modeData && modeData.slots && modeData.slots.length > 0) {
        return modeData.slots;
      }
    }
    if (!defaultSlots || !dateStr) return [];
    var day = new Date(dateStr + 'T12:00:00').getDay();
    return defaultSlots.filter(function (s) {
      return s.availableDays && s.availableDays.indexOf(day) >= 0;
    });
  }

  /**
   * Filter available slots for a date.
   * @param {Array} slots - default timeslot configs
   * @param {string} dateStr - YYYY-MM-DD
   * @param {Array} blackoutDates - [{ date }]
   * @param {Function} isPastCutoffFn - (slot, dateStr) => boolean
   * @param {Array} [overrideDays] - override day configs
   * @param {string} [mode] - 'delivery' | 'collection' | 'express'
   */
  function filterAvailableSlots(slots, dateStr, blackoutDates, isPastCutoffFn, overrideDays, mode) {
    if (!dateStr) return [];
    if (blackoutDates && blackoutDates.some(function (b) { return b.date === dateStr; })) return [];
    var resolved = resolveSlotsForDate(slots, dateStr, overrideDays, mode);
    if (isPastCutoffFn) {
      resolved = resolved.filter(function (s) { return !isPastCutoffFn(s, dateStr); });
    }
    return resolved;
  }

  window.WF_LD_SLOT_UTILS = {
    filterAvailableSlots: filterAvailableSlots,
    findOverrideForDate: findOverrideForDate,
    resolveSlotsForDate: resolveSlotsForDate,
  };
})();
